// extracted by mini-css-extract-plugin
export var container = "_v3-0";
export var table = "_v3-2";
export var tableWrapper = "_v3-1";